// Traduzioni in Italiano
export const it = {
  common: {
    welcome: "Benvenuto",
    logout: "Esci",
    login: "Accedi",
    loading: "Caricamento...",
    error: "Errore",
    success: "Successo",
    cancel: "Annulla",
    save: "Salva",
    delete: "Elimina",
    edit: "Modifica",
    back: "Indietro",
    next: "Avanti",
    previous: "Precedente",
    search: "Cerca",
    filter: "Filtra",
    close: "Chiudi",
  },
  login: {
    title: "Accedi",
    subtitle: "Accedi al tuo account Auriga",
    button: "Accedi con Authentik",
    checking: "Verifica sessione...",
    redirecting: "Reindirizzamento...",
  },
  dashboard: {
    title: "Dashboard",
    welcome: "Benvenuto",
    userInfo: "Informazioni utente",
    email: "Email",
    id: "ID",
    apiInfo: "Informazioni API",
    noUserData: "Nessuna informazione utente disponibile.",
    sections: "Sezioni disponibili",
    qualityDashboard: "Dashboard Qualità",
    maintenanceDashboard: "Dashboard Manutenzione",
    adminDashboard: "Dashboard Amministrazione",
    noAccess: "Non hai accesso alle sezioni specializzate. Contatta l'amministratore per ottenere i permessi.",
    permissions: "Informazioni sui permessi",
    factories: "Fabbriche",
    roles: "Ruoli",
    departments: "Dipartimenti",
    groups: "Gruppi",
    none: "Nessuno",
    noneFound: "Nessuno",
  },
  quality: {
    title: "Dashboard Qualità",
    permissions: "Informazioni sui permessi",
    accessChecks: "Controlli di accesso",
    factoryAccess: "Accesso a",
    roleIn: "Ruolo",
    features: "Funzionalità Qualità",
    inspections: "Gestione ispezioni",
    qualityControl: "Controllo qualità",
    nonConformities: "Report di non conformità",
    trends: "Analisi delle tendenze",
  },
  maintenance: {
    title: "Dashboard Manutenzione",
    permissions: "Informazioni sui permessi",
    accessChecks: "Controlli di accesso",
    factoryAccess: "Accesso a",
    roleIn: "Ruolo",
    features: "Funzionalità Manutenzione",
    planning: "Pianificazione manutenzione",
    workOrders: "Ordini di lavoro",
    equipment: "Gestione attrezzature",
    history: "Storico manutenzioni",
  },
  admin: {
    title: "Dashboard Amministrazione",
    permissions: "Informazioni sui permessi",
    accessChecks: "Controlli di accesso",
    group: "Gruppo",
    features: "Funzionalità Amministrazione",
    users: "Gestione utenti",
    system: "Configurazione sistema",
    reports: "Report amministrativi",
    audit: "Audit e log",
  },
  navigation: {
    dashboards: "Dashboard",
  },
  errors: {
    notAuthenticated: "Non autenticato",
    accessDenied: "Accesso negato",
    noPermission: "Non hai il permesso di accedere a questa sezione.",
    requirements: "Requisiti",
    factory: "Fabbrica",
    department: "Dipartimento",
    role: "Ruolo",
    group: "Gruppo",
    backToDashboard: "Torna al Dashboard",
  },
};








